import { Link } from 'react-router-dom'
import dayjs from 'dayjs'
import { Calendar } from 'lucide-react'

import {
    DataTableColumn,
    FilterItemConfig,
    FilterToggle,
} from '@/components/ui/data-table-customized'
import { Badge } from '@/components/ui/badge'
import { Supplier } from '../../types/response'
import { paths } from '@/utils/path'

// === Columns ===

export const getSupplierColumns = (): DataTableColumn<Supplier>[] => [
    {
        key: 'name',
        title: 'Name',
        width: 250,
        pinned: 'left',
        render: (_value, row) => (
            <Link
                to={`${paths.warehouseSuppliers}/${row.id}`}
                className="text-blue-600 hover:underline font-medium"
            >
                {row.name}
            </Link>
        ),
    },
    {
        key: 'contact_person',
        title: 'Contact',
        width: 160,
        render: (value) => (
            <span className="text-sm">{(value as string) || '-'}</span>
        ),
    },
    {
        key: 'email',
        title: 'Email',
        width: 200,
        render: (value) => (
            <span className="text-sm">{(value as string) || '-'}</span>
        ),
    },
    {
        key: 'phone',
        title: 'Phone',
        width: 140,
        render: (value) => (
            <span className="text-sm">{(value as string) || '-'}</span>
        ),
    },
    {
        key: 'is_active',
        title: 'Status',
        width: 120,
        render: (_value, row) => (
            <Badge variant={row.is_active ? 'default' : 'secondary'}>
                {row.is_active ? 'Active' : 'Inactive'}
            </Badge>
        ),
    },
    {
        key: 'created_at',
        title: 'Created',
        width: 150,
        render: (value) => {
            const date = dayjs(value as string)
            return (
                <div
                    className="flex items-center gap-2"
                    title={date.format('YYYY-MM-DD HH:mm:ss')}
                >
                    <Calendar className="h-3.5 w-3.5 text-muted-foreground" />
                    <span className="text-sm">{date.format('YYYY-MM-DD')}</span>
                </div>
            )
        },
    },
]

// === Filters ===

const supplierStatusOptions = [
    { value: 'true', label: 'Active' },
    { value: 'false', label: 'Inactive' },
]

export const getSupplierFilterItems = (): FilterItemConfig[] => [
    {
        type: 'select',
        name: 'is_active',
        label: 'Status',
        placeholder: 'Filter by status',
        options: supplierStatusOptions,
    },
]

// === Filter Toggles (column visibility) ===

export const getSupplierFilterToggles = (): FilterToggle[] => [
    { key: 'name', label: 'Name' },
    { key: 'contact_person', label: 'Contact' },
    { key: 'email', label: 'Email' },
    { key: 'phone', label: 'Phone' },
    { key: 'is_active', label: 'Status' },
    { key: 'created_at', label: 'Created' },
]
